import PublicationsFilter from './filters/PublicationsFilter.js';
import BaseFilterController from './base/BaseFilterController.js';

const filterRegistry = {
  publication: PublicationsFilter,
};

const postFilter = {
  init() {
    const sections = document.querySelectorAll('[data-posts-filter-js]');
    if (!sections.length) return;

    sections.forEach(section => {
      // Use data-filter-type if present, otherwise fallback to data-post-type
      const filterType = section.dataset.filterType || section.dataset.postType;
      const Controller = filterRegistry[filterType] || BaseFilterController;
      new Controller(section);
    });
  },
};

export default postFilter;
